import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWriteInsuranceInformation: Map<string, ConfirmationData> = new Map([
    ["ce87e45b-6843-4def-a6de-7843c5bdfec9|48988f29-3079-4fef-b43f-fa5ac53700ef", { label: "Sí/No" }],
    ["4c30d99b-860e-4203-8763-5329f1e17222|b404adb7-9675-4ef2-91a2-e8029f127e9f", { label: "Sí/No" }],
    ["2f455039-6115-4554-b4e6-fdbf85e2c8de|a4b17cd9-d538-4e7d-82a9-61c280a835da", { label: "Sí/No" }],
    ["7c337ecf-89ff-4aa2-935a-2a3e25bc4672|29e42fe5-41b3-493b-bff4-97b1fd018aa6", { label: "Sí/No" }],

    ["1df83e06-37dd-406f-8004-a6f2a4dde0dd", { hidden: true }],
    ["c4004d9c-7d59-4823-9b8f-967aaf3a2e51", { hidden: true }],
]);



